import React from "react";
import * as Icons from "lucide-react";
import { services, contact } from "../../mock";
import { SectionHeading } from "../SectionHeading";
import Reveal from "../Reveal";
import { MessageCircle } from "lucide-react";

const Services = () => {
  return (
    <section className="py-20 md:py-28 bg-[#08080f] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SectionHeading
          eyebrow="What We Offer"
          title="Services We"
          highlight="Provide"
          subtitle="From online cricket id to live casino, everything you need for non-stop action — all under one trusted roof."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Target;
            return (
              <Reveal key={s.title} delay={i * 80}>
                <div className="card-neon rounded-2xl p-7 h-full group">
                  <div className="h-14 w-14 grid place-items-center rounded-xl bg-gradient-to-br from-[#00ff87]/20 to-[#00e5ff]/20 text-[#00ff87] mb-5 group-hover:scale-110 transition-transform">
                    <Icon size={26} />
                  </div>
                  <h3 className="font-display font-semibold text-xl text-white mb-2">{s.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <a
            href={contact.whatsapp}
            target="_blank"
            rel="noreferrer"
            className="btn-neon inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl font-display font-semibold"
          >
            <MessageCircle size={20} /> Start Playing Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
